import { Reveal, MaskedLines } from "@/components/site/Reveal";
import { BookDemo } from "@/components/site/BookDemo";
import { DEMO } from "@/data/pageCopy";

const { kicker, h1Lines, lead } = DEMO;

export default function DemoPage() {
  return (
    <div data-testid="demo-page">
      <section className="relative pt-32 md:pt-40 pb-4 overflow-hidden">
        <div className="pointer-events-none absolute inset-0 opacity-[0.05]" style={{
          backgroundImage: "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "64px 64px",
        }} />
        <div className="relative mx-auto max-w-[1400px] px-6 md:px-12">
          <Reveal><p className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#5B8CFF] mb-5">{kicker}</p></Reveal>
          <h1 className="font-heading font-medium tracking-tight leading-[0.98] text-4xl md:text-6xl text-white max-w-3xl">
            <MaskedLines lines={h1Lines} delay={0.1} />
          </h1>
          <Reveal delay={0.35}>
            <p className="mt-7 text-lg text-neutral-400 max-w-xl leading-relaxed">{lead}</p>
          </Reveal>
        </div>
      </section>
      <BookDemo />
    </div>
  );
}
